import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Button,
  List,
  SwipeableDrawer,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Dialog,
  Box,
  styled,
  useTheme,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useForm, FormProvider } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  documentsActions,
  fileActions,
  workflowActions,
  addTitleLegoCurrent,
} from "../../store/actions";
import {
  CustomLoadingOverlay,
  GenericContainer,
  FullCameraCapture,
  FullUploadFiles,
  CustomUploadCamera,
  Buttons,
  ButtonsLined,
  GenericStatusElement,
  GenericButtonList,
  AlertConfirm,
  InputField,
  GenericDialog,
  UseImage,
  GenericContainerCenter,
  Alert,
} from "../../components";
import {
  b64toUrl,
  GetMimeType,
  blobToBase64,
  coreFunctions,
  IsDevice, ClearSession
} from "../../utils";
import { SeeDocBeforeLoad } from "./SeeDocBeforeLoad";
import cargaDocImg from "../../assets/cargaDoc.svg";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  drawer: {
    marginLeft: "20% !important",
    width: "60% !important",
    borderRadius: "5px 5px 0px 0px !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "5px 24px",
    [theme.breakpoints.only("xs")]: {
      marginLeft: "0% !important",
      width: "100% !important",
    },
  },
  drawerCenter: {
    paddingTop: "24px",
    width: "90%",
    [theme.breakpoints.only("xs")]: {
      width: "95%",
    },
  },
  cancelIcon: {
    marginRight: theme.spacing(2),
  },
  helpListInstructions: {
    display: "flex",
    marginBottom: theme.spacing(1),
  },
}));

export default function CargarDocsComponent(props) {
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState, setValue } = useForm({
    mode: "onBlur",
  });
  const localStyles = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const dialogStyle = {}; //mainStyles.customDialogStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [logoutOnSave, setLogoutOnSave] = useState("");
  const [sections, setSections] = useState([]);
  const [docsAndIds, setDocsAndIds] = useState([]);
  const [metadatos, setMetadatos] = useState([]);
  const [fields, setFields] = useState([]);

  // const [loadView, setLoadView] = useState(false);
  const [continueButton, setContinueButton] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showCapturedDocAlert, setShowCapturedDocAlert] = useState(false);
  const [capturedDocAlert, setCapturedDocAlert] = useState(false); //new
  const [helpOpen, setHelpOpen] = useState(false);
  // const [openFileLoader, setOpenFileLoader] = useState(false);
  const [ocrErrorAlert, setOcrErrorAlert] = useState(false);
  const [qrProcess, setQrProcess] = useState(false); //to enable sending the info with or without metadata
  const [askFile, setAskFile] = useState(false);
  const [cerOrKeyFile, setCerOrKeyFile] = useState(false);

  const [transId, setTransId] = useState(null); //for the metadata and multiple sections

  const [nameStage, setNameStage] = useState("");
  // const [descriptionStage, setDescriptionStage] = useState("");
  const [ext, setExt] = useState("");
  const [docType, setDocType] = useState("");
  // const [docName, setDocName] = useState(""); //for the metadata
  const [sectionName, setSectionName] = useState(""); //for the metadata
  const [captureType, setCaptureType] = useState("");

  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);
  const [documentId, setDocumentId] = useState(0);
  const [sectionId, setSectionId] = useState(0);
  const [totalSections, setTotalSections] = useState(0);
  const [toTransfer, setToTransfer] = useState(0);
  const [extensionsDoc, setExtensionsDoc] = useState([]);
  const [texSubTittle, setTexSubTittle] = useState("");
  const [stageProps, setStageProps] = useState("");
  const [isValidOcr, setisValidOcr] = useState(false);
  const [documentNameCurrent, setDocumentNameCurrent] = useState("");

  const [ocrInfo, setOcrInfo] = useState({}); //for the metadata
  const [loadMicroblick, setLoadMicroblick] = useState(false);

  const fileLoader = useRef(null);
  const cerFileLoader = useRef(null); //new
  const keyFileLoader = useRef(null); //new

  //New Variables
  const [initCamera, setInitCamera] = useState(false);
  const [listDocsItems, setListDocsItems] = useState([]);
  const [documentTypesList, setDocumentTypesList] = useState([]);
  const [showDrawerOptionsType, setShowDrawerOptionsType] = useState(false);
  const [initChangeFile, setInitChangeFile] = useState(false);
  const [base64File, setBase64File] = useState("");
  const [extFileCurrent, setExtFileCurrent] = useState("");
  const [loadView, setLoadView] = useState(false);
  const [uploadFileProcess, setUploadFileProcess] = useState(false);
  const [openModalOCR, setOpenModalOCR] = useState(false);
  const [documenttoView, setDocumenttoView] = useState(null);
  const [metaToSend, setMetaToSend] = useState(false);
  const [sending, setSending] = useState(false);
  const [isSelfie, setIsSelfie] = useState("");
  const [filterDocRefuseds, setFilterDocRefuseds] = useState(false);
  const [docsRefused, setDocsRefused] = useState(false);

  //New State
  const folioId = location.state?.folioId;
  console.log("location.-------------: ", location);

  //Redux hooks
  // const wf = useSelector(state => state.Workflow)
  const auth = useSelector((state) => state.Authentication);
  const file = useSelector((state) => state.FileInfo);
  // const uploadDoc = useSelector((state) => state.UploadDocuments);

  const uploadSecDoc = useSelector((state) => state.UploadSections);
  const cargaDocWithSecResponse = useSelector(
    (state) => state.CargaDocWithSecData
  );
  const ocrResponse = useSelector((state) => state.OcrData);
  const continueWF = useSelector((state) => state.ContinueWorkflow);
  const registeredData = useSelector((state) => state.MetadaData);
  const actorId = location.state?.actorId;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addTitleLegoCurrent("Carga de documentos"));
    makeMainDispatch();
  }, []);

  useEffect(() => {
    setLoadView(file.loading);
    if (file.items != undefined && file.items != null) {
      // console.log("file.items : ", file.items)
      setCurrentStage(file.items.Stage?.CurrentStageGroup);
      setTotalStage(file.items.Stage?.TotalStageGroups);
      setNameStage(file.items.Stage?.Name);

      if (file.items.Stage?.DocumentalCategory?.DocumentalGroups?.length > 0) {
        setIsSelfie(
          file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.Name ===
            "Selfie" && true
        );
      }

      // setDescriptionStage(file.items.Stage?.Description);
      dispatch(addTitleLegoCurrent(file.items.Stage?.Description));

      let textDesc = file.items.Stage?.Properties?.find(
        (item) => item.Name == "textSubTittle"
      )?.Value;
      setTexSubTittle(textDesc);

      let onlyRejected = file.items.Stage?.Properties?.find(
        (item) => item.Name == "FiltterDocumentRefused"
      )?.Value;
      if (onlyRejected === "1") setFilterDocRefuseds(true);

      //verificar si hay rechazados
      const hayDocumentosRechazados =
        file.items.Stage.DocumentalCategory?.DocumentalGroups?.some((docx) =>
          docx.DocumentTypes?.some(
            (docType) => docType?.Document?.Status === "Rechazado"
          )
        );
      setDocsRefused(hayDocumentosRechazados);
      let LogoutOnSave = file.items?.Stage?.Properties?.find(
        ({ Name }) => Name === "LogoutOnSave"
      )?.Value;
      setLogoutOnSave(LogoutOnSave);
      console.log(
        "file.items.Stage.DocumentalCategory?.DocumentalGroups................: ",
        file.items.Stage.DocumentalCategory?.DocumentalGroups
      );
      let itemsToList =
        file.items.Stage.DocumentalCategory?.DocumentalGroups?.map((item) => {
          return {
            ...item,
            Types: item.DocumentTypes.map((item) => {
              return {
                ...item,
                Options: [{ Option: item.Name, Value: item.Id }],
              };
            }),
            Capture: item.DocumentTypes[0].Sections[0].CaptureType,
            ActiveNSections:
              item.DocumentTypes[0].Sections?.length > 1 ? true : false,
            Sections: item.DocumentTypes[0].Sections,
            Description: item.DocumentTypes[0].Description,
          };
        });
      setListDocsItems(itemsToList);
      // console.log("itemsToList_1: ", itemsToList)
    } else if (file.error != undefined) {
      alert(file.error);
    }
  }, [file]);

  // useEffect(async () => {
  useEffect(() => {
    setLoadView(file.loading);
    if (base64File != undefined && base64File != null && base64File != "") {
      // console.log('DOBLE PETICION')
      // console.log(ocrInfo.ocr)
      // askforTransactionId()
      // ocrInfo.ocr == 0 ? askforTransactionId() : askforTransactionId();
      // setLoadView(true)

      // let mimeType = extFileCurrent == ".pdf" ? 'application/pdf' : 'image/jpeg'
      // const blob = await B64toBlobAsync(base64File, mimeType);
      // const blobUrl = URL.createObjectURL(blob);
      // setDocumenttoView(blobUrl);
      console.log(
        "ocrInfo.ocr*****: ",
        ocrInfo.ocr,
        " - base64File: ",
        base64File
      );
      if (parseInt(ocrInfo.ocr) == 0) {
        sendDocAction();
      } else {
        askforTransactionId();
        setLoadView(true);

        async function fetchData() {
          const blobUrl = await b64toUrl(
            `${GetMimeType(extFileCurrent)},${base64File}`
          );
          setDocumenttoView(blobUrl);
        }
        fetchData();

        // // let mimeType = extFileCurrent == ".pdf" ? 'application/pdf' : 'image/jpeg'
        // // const blob = await B64toBlobAsync(base64File, mimeType);
        // const blobUrl = b64toUrl(base64File) //URL.createObjectURL(blob);
        // setDocumenttoView(blobUrl);
      }
    }
  }, [base64File]);

  // useEffect(() => {
  //   console.log("uploadDoc: uploadDoc.items: ", sending, uploadDoc.items)
  //   if (uploadDoc.items != undefined && uploadDoc.items?.TransactionId != null && sending) {
  //     setOpenModalOCR(false);
  //     setMetadatos([]);
  //     makeMainDispatch();
  //     setisValidOcr(false);
  //     setSending(false)
  //     // localStorage.setItem("TransactionId", uploadDoc.items.TransactionId); //Almacenar TransactionId
  //     // let request = {
  //     //   File_id: folioId,
  //     //   DocumentType_Id: file.items.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes[0].Id,
  //     //   TransactionId: uploadDoc.items.TransactionId
  //     // }
  //     // console.log("Request OCR: ", request)
  //     // dispatch(documentsActions.GetOcrData(request));
  //   }
  //   if (uploadDoc.error != undefined && sending) {
  //     setLoadView(false);
  //     setSending(false)
  //     alert(uploadDoc.error);
  //   }
  // }, [uploadDoc]);

  useEffect(() => {
    console.log("isValidOcr", isValidOcr);
    if (
      ocrResponse.items != undefined &&
      ocrResponse.items?.Metadatos != null &&
      uploadFileProcess
    ) {
      if (ocrResponse.items.Metadatos[0].Name == "ProcessError") {
        setOcrErrorAlert(true);
        console.log("ENTRO EN FALSE");
        setOpenModalOCR(false);
        setLoadView(false);
      } else if (ocrResponse.items.Metadatos[0].Name != "ProcessError") {
        // setMetadatos(ocrResponse.items.Metadatos);
        console.log("ENTRO EN 1");
        if (isValidOcr === true) {
          console.log("entra a cambiar", isValidOcr);
          setOpenModalOCR(false);
          setMetadatos([]);
          makeMainDispatch();
          setisValidOcr(false);
        } else {
          console.log("ENTRO EN 2");
          setMetadatos(ocrResponse.items.Metadatos);
          setOpenModalOCR(true);
        }
      }
    }
    if (ocrResponse.error != undefined && uploadFileProcess) {
      setLoadView(false);
      setUploadFileProcess(false);
      alert(ocrResponse.error);
    }
  }, [ocrResponse]);

  useEffect(() => {
    console.log(
      "setDocumentNameCurrent:----------ocrInfo.ocr--------------------------: ",
      documentNameCurrent,
      ocrInfo.ocr
    );
    if (documentNameCurrent != "" && parseInt(ocrInfo.ocr) != 0) {
      // setDocumentNameCurrent(documentNameCurrent)
      setFields(coreFunctions.GetNewFieldName(documentNameCurrent));
    }
  }, [documentNameCurrent]);

  // console.log('cargaDocWithSecResponse', cargaDocWithSecResponse);
  useEffect(() => {
    // console.log("cargaDocWithSecResponse: ", cargaDocWithSecResponse)
    console.log("cargaDocWithSecResponse", cargaDocWithSecResponse);
    console.log("loading", cargaDocWithSecResponse.loading);

    if (
      cargaDocWithSecResponse.items === undefined ||
      cargaDocWithSecResponse.items === null ||
      cargaDocWithSecResponse.items === ""
    ) {
    } else {
      if (cargaDocWithSecResponse?.items != undefined && uploadFileProcess) {
        if (
          (cargaDocWithSecResponse.items?.UploadSectionResponseData?.Result
            ?.Id != null ||
            cargaDocWithSecResponse.items?.UploadSectionResponseData?.Result
              ?.Id != undefined) &&
          !metaToSend
        ) {
          console.log("cargaDocWithSecResponse_paso1_metaToSend: ", metaToSend);
          // setLoadView(false);
          console.log("ENTRA A CERRAR");
          setisValidOcr(false);
          // closeDocAction();
          // makeMainDispatch();
        } else if (
          (cargaDocWithSecResponse.items?.UploadSectionResponseData?.Result
            ?.Id != null ||
            cargaDocWithSecResponse.items?.UploadSectionResponseData?.Result
              ?.Id != undefined) &&
          metaToSend
        ) {
          console.log("cargaDocWithSecResponse_paso2_metaToSend: ", metaToSend);
          console.log("ENTRO EN FALSE");
          setOpenModalOCR(false);
          // setMetaToSend(false)
          dispatch(
            documentsActions.RegisterMetadata({
              Document_Id:
                cargaDocWithSecResponse.items?.UploadSectionResponseData?.Result
                  ?.Id,
              Metadata: metadatos,
            })
          );
          setisValidOcr(true);
          // makeMainDispatch();
        }
      }

      console.log("cargaDocWithSecResponse", cargaDocWithSecResponse);
      if (
        cargaDocWithSecResponse.items != undefined ||
        cargaDocWithSecResponse.items != null ||
        cargaDocWithSecResponse.items != ""
      ) {
        if (
          cargaDocWithSecResponse?.items?.TransactionId != undefined ||
          cargaDocWithSecResponse?.items?.TransactionId != null ||
          cargaDocWithSecResponse?.items?.TransactionId != ""
        ) {
          console.log("TERMINA AQUI");
          localStorage.setItem(
            "TransactionId",
            cargaDocWithSecResponse?.items?.TransactionId
          ); //Almacenar TransactionId
          let request = {
            File_id: folioId,
            DocumentType_Id:
              file.items?.Stage?.DocumentalCategory?.DocumentalGroups[0]
                ?.DocumentTypes[0]?.Id,
            TransactionId: cargaDocWithSecResponse?.items?.TransactionId,
          };
          console.log("Request OCR: ", request);
          dispatch(documentsActions.GetOcrData(request));
        }
      }

      if (cargaDocWithSecResponse.error != undefined && uploadFileProcess) {
        console.log(cargaDocWithSecResponse.error);
        setLoadView(false);
        alert(cargaDocWithSecResponse.error);
      }
    }
  }, [cargaDocWithSecResponse.loading]);

  useEffect(() => {
    console.log("sending, uploadSecDoc.items: ", sending, uploadSecDoc.items);
    if (uploadSecDoc.items != undefined && sending) {
      setLoadView(false);
      closeDocAction();
      makeMainDispatch();
      setSending(false);
      setOpenModalOCR(false);
      setMetadatos([]);
      setisValidOcr(false);
      setBase64File(null);
    } else if (uploadSecDoc.error != undefined && sending) {
      setLoadView(false);
      alert(uploadSecDoc.error);
      setOpenModalOCR(false);
      setSending(false);
      setBase64File(null);
    }
  }, [uploadSecDoc]);

  useEffect(() => {
    if (registeredData.items && uploadFileProcess && sending) {
      console.log("ENTRA 1");
      makeMainDispatch();
      setLoadView(false);
      closeDocAction();
      setContinueButton(true);
    } else if (
      registeredData.error != undefined &&
      uploadFileProcess &&
      sending
    ) {
      console.log("ENTRA 2");
      alert(registeredData.error);
      setOpenModalOCR(false);
      setLoadView(false);
    }
  }, [registeredData]);

  // console.log(continueWF)

  useEffect(() => {
    console.log("ENTRA AQUI AVANZA EL FLUJO");
    //new
    if (
      continueWF.items != undefined &&
      continueWF.items?.Stage != undefined &&
      loadView &&
      !qrProcess
    ) {
      console.log(
        "continueWF.items.Stage: -------- ------ ----",
        continueWF.items.Stage
      );
      setLoadView(false);
      let stage = continueWF.items.Stage;
      let stageName = stage.Name;
      let stageId = stage.Id;

      let LogoutOnSave = file.items?.Stage?.Properties?.find(({ Name }) => Name === "LogoutOnSave")?.Value

      if(LogoutOnSave && LogoutOnSave == "1"){
        //Logout y redireccion a login
        console.log("LogoutOnSave close sesion")
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate('/auth/');
          }
        );
        return
      }

      if (stageName == "Carga documental") {
        setNameStage(stage.Name);
        // setDescriptionStage(stage.Description);
        dispatch(addTitleLegoCurrent(stage.Description));
        // setFolioId(stage.File.Id);
        console.log("file.items.Stage: ", stage);
        console.log("file.items.Stage?.Properties: ", stage.Properties);

        let textDesc = stage.Properties?.find(
          (item) => item.Name == "textSubTittle"
        )?.Value;
        setTexSubTittle(textDesc);

        if (
          stage.DocumentalCategory != undefined &&
          stage.DocumentalCategory != null
        ) {
          const itemsToList = stage.DocumentalCategory.DocumentalGroups.map(
            (item) => {
              return {
                Id: item.Id,
                Name: item.Name,
                Required: item.Required,
                // Description: item.Description,
                Types: item.DocumentTypes.map((item) => {
                  return {
                    ...item,
                    Options: [{ Option: item.Name, Value: item.Id }],
                  };
                }),
                Capture: item.DocumentTypes[0].Sections[0].CaptureType,
                ActiveNSections:
                  item.DocumentTypes[0].Sections?.length > 1 ? true : false,
                Sections: item.DocumentTypes[0].Sections,
                Description: item.DocumentTypes[0].Description,
              };
            }
          );
          console.log("itemsToList_2: ", itemsToList);
          setListDocsItems(itemsToList);
        }
      } else if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        console.log("LogoutOnSave::clearsesion");
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
        return;
      }

      let nextComponent = coreFunctions.GetLegoNext(stageName);
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else if (
      continueWF.items != undefined &&
      continueWF.items?.Stage != undefined &&
      loadView &&
      qrProcess
    ) {
      if (continueWF.items.Stage.Name == "Carga documental") {
        closeDocAction();
        console.log("ENTRA A CERRAR");
        makeMainDispatch();
      } else if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        console.log("LogoutOnSave::clearsesion");
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
      } else {
        let nextComponent = "QrCloseProcess";
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { currentStage, totalStage },
        });
      }
      console.log("response", continueWF.items);
    }

    if (continueWF.error != undefined && loadView) {
      setLoadView(false);
      alert(continueWF.error);
    }
  }, [continueWF]);

  // console.log('metaToSend', metaToSend)

  useEffect(() => {
    if (listDocsItems?.length > 0) {
      if (
        setLoadedDocs(listDocsItems) === listDocsItems.length &&
        listDocsItems.length > 0
      ) {
        const hayDocumentoNoAprobado = listDocsItems?.some((docx) =>
          (docx?.Types || docx?.DocumentTypes)?.some(
            (docType) =>
              (docType?.Document?.Status === "Rechazado" ||
                !docType?.Document) &&
              docType?.Required === true
          )
        );

        console.log(
          "hayDocumentoNoAprobado 0",
          listDocsItems,
          hayDocumentoNoAprobado
        );
        setContinueButton(!hayDocumentoNoAprobado);

        if (metaToSend === true) {
          handleContinue();
        }
      } else {
        const hayDocumentoNoObligatorio = listDocsItems?.some((docx) =>
          (docx?.Types || docx?.DocumentTypes)?.some(
            (docType) => docType?.Required === false
          )
        );

        const hayDocumentosRequeridos = listDocsItems?.some((docx) =>
          (docx?.Types || docx?.DocumentTypes)?.some(
            (docType) => docType?.Required === true
          )
        );

        const hayDocumentoNoAprobadoCargado = listDocsItems?.some((docx) =>
          (docx?.Types || docx?.DocumentTypes)?.some(
            (docType) =>
              (docType?.Document?.Status === "Rechazado" ||
                !docType.Document) &&
              docType?.Required === true
          )
        );

        if (
          hayDocumentoNoObligatorio == true &&
          hayDocumentosRequeridos == false
        ) {
          console.log("ENTRANDO 1");
          setContinueButton(true);
        } else if (
          hayDocumentoNoAprobadoCargado == false &&
          hayDocumentoNoObligatorio == true
        ) {
          console.log("ENTRANDO 2");
          setContinueButton(true);
        } else if (filterDocRefuseds && !docsRefused) {
          console.log("ENTRANDO 3");
          setContinueButton(true);
        } else {
          console.log("ENTRANDO 4");
          setContinueButton(false);
        }
        console.log(
          "hayDocumentoNoAprobado 1",
          hayDocumentoNoAprobadoCargado,
          hayDocumentosRequeridos,
          hayDocumentoNoObligatorio,
          listDocsItems
        );
      }
    }
  }, [listDocsItems]);

  useEffect(() => {
    console.log("DocumentTypesList", documentTypesList);
    if (showCapturedDocAlert) {
      AlertConfirm(
        {
          icon: "warning",
          html: (
            <Box>
              {documentTypesList[0]?.Document?.Status === "Rechazado" ? (
                <Box>
                  <Typography
                    textAlign={"center"}
                    variant="body1"
                    sx={{
                      mt: 1,
                      textAlign: "center",
                      maxWidth: 400,
                      mx: "auto",
                    }}
                  >
                    <b>{t("document_capture_rejected")}</b>
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    variant="body1"
                    sx={{
                      mt: 1,
                      textAlign: "center",
                      maxWidth: 400,
                      mx: "auto",
                    }}
                  >
                    {
                      documentTypesList[0]?.Document?.Validation
                        ?.ValidationMessage
                    }
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    variant="body1"
                    sx={{
                      mt: 1,
                      textAlign: "center",
                      maxWidth: 400,
                      mx: "auto",
                    }}
                  >
                    <b>{t("document_capture_again")}</b>
                  </Typography>
                </Box>
              ) : (
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("document_already_captured")}
                </Typography>
              )}
            </Box>
          ),
          okbtntext:
            documentTypesList[0]?.Document?.Status === "Rechazado"
              ? t("capture_now")
              : t("general_accept"),
          notbtntext:
            documentTypesList[0]?.Document?.Status === "Rechazado"
              ? t("capture_another_time")
              : t("legal_reject"),
        },
        (result) => {
          if (result.isConfirmed) {
            if (documentTypesList[0].Options.length > 1) {
              setShowDrawerOptionsType(true);
            } else {
              setInitChangeFile(true);
            }
          } else if (result.dismiss === "cancel" && result.isDismissed) {
            firstCloseLevel();
          }
          setShowCapturedDocAlert(false);
        }
      );
    }
  }, [showCapturedDocAlert]);

  const setLoadedDocs = (array) => {
    let loadedDocs = null;
    console.log("setLoadedDocs array: ", array);
    let filterAray = array.filter(
      (item) =>
        (item.Name != "Identificación oficial" && item?.Sections?.length > 1) ||
        item?.Sections?.length == 1
    );
    console.log("setLoadedDocs filterAray: ", filterAray);
    filterAray?.forEach((element) => {
      if (ifCapture(element.Types)) {
        loadedDocs = loadedDocs + 1;
        console.log("loadedDocs*****1: ", loadedDocs);
      } else if (!ifCapture(element.Types)) {
        loadedDocs = loadedDocs + 0;
        console.log("loadedDocs*****2: ", loadedDocs);
      }
    });
    return loadedDocs;
  };

  const makeMainDispatch = () => {
    console.log("makeMainDispatch: folioId: ", folioId);
    dispatch(fileActions.GetFileInfo(folioId));
  };

  const firstCloseLevel = () => {
    setDocumentTypesList([]);
    setDocumentId(0);
    setOcrInfo({});
    setSectionId(0);
    setSectionName("");
    setDocumentNameCurrent("");
    setSections([]);
    setFields([]);
    setExtFileCurrent("");
  };

  const closeDocAction = () => {
    console.log("ENTRO EN FALSE");
    setOpenModalOCR(false);
    firstCloseLevel();
    setShowDrawerOptionsType(false);
    setMetadatos([]);
    setMetaToSend(false);
    setisValidOcr(true);
  };

  const handleContinue = () => {
    setLoadView(true);
    console.log("entro a avanzar");
    dispatch(
      workflowActions.ContinueWorkflowAction({
        File_Id: folioId,
      })
    );
  };

  const ifCapture = (array) => {
    let findIfCapture = array.filter((item) => item.Document != null);
    // console.log("findIfCapture", findIfCapture)
    if (findIfCapture.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const setTypeOfSelection = (list, uploaded, capture) => {
    console.log(
      "setTypeOfSelection---------------------------------: ",
      list,
      uploaded,
      capture
    );
    // setAskFile(true);
    setDocumentTypesList(list);
    setCaptureType(capture);
    if (list.length > 1 && uploaded == "no") {
      console.log("---------------IF 4------------------: ");
      setDocumentId(0);
      setShowDrawerOptionsType(true);
    } else if (list.length === 1 && uploaded == "yes") {
      if (list[0].Document.Status === "Aprobado") {
        return null;
      } else {
        console.log("---------------IF 5-----------------:", list);
        setDocumentId(list[0].Id);
        setOcrInfo(coreFunctions.GetOcrValue(list[0].Properties));
        setShowCapturedDocAlert(true);
        setDocumentNameCurrent(list[0].Name);
        setSectionId(list[0].Sections[0].Id);
        setSectionName(list[0].Sections[0].Name);
        setExtensionsDoc(list[0]?.Sections[0]?.AllowedExtensions?.join(", "));
      }
    } else if (list.length > 1 && uploaded == "yes") {
      console.log("---------------IF 6------------------: ");
      setDocumentId(0);
      setShowCapturedDocAlert(true);
    } else if (list.length === 1 && uploaded == "no" && capture == "Camera") {
      console.log("---------------IF 7------------------: ");
      setDocumentId(list[0].Id);
      setOcrInfo(coreFunctions.GetOcrValue(list[0].Properties));
      setSectionId(list[0].Sections[0].Id);
      setSectionName(list[0].Sections[0].Name);
      setDocumentNameCurrent(list[0].Name);
      setExtensionsDoc(list[0]?.Sections[0]?.AllowedExtensions?.join(", "));
      setBase64File(null);
      setInitCamera(true);
      setShowAlert(false);
      setExtFileCurrent(".jpg");
    } else if (
      list.length === 1 &&
      uploaded == "no" &&
      capture == "Document Upload, Camera"
    ) {
      console.log("---------------IF 8------------------: ", list);
      setDocumentId(list[0].Id);
      setOcrInfo(coreFunctions.GetOcrValue(list[0].Properties));
      setSectionId(list[0].Sections[0].Id);
      setSectionName(list[0].Sections[0].Name);
      setDocumentNameCurrent(list[0].Name);
      setExtensionsDoc(list[0]?.Sections[0]?.AllowedExtensions?.join(", "));
      setBase64File(null);
      setShowAlert(false);
      // setInitChangeFile(true)
      // setExtFileCurrent(".pdf")
      AlertConfirm(
        {
          icon: "success",
          html: (
            <Box>
              <Typography
                textAlign={"center"}
                variant="body1"
                sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
              >
                {t("document_upload_message")}
              </Typography>
            </Box>
          ),
          okbtntext: t("document_upload_file"),
          notbtntext: t("document_upload_picture"),
        },
        (result) => {
          if (result.isConfirmed) {
            setInitChangeFile(true);
          } else if (result.dismiss === "cancel" && result.isDismissed) {
            setInitCamera(true);
            setExtFileCurrent(".jpg");
          }
          RestoreValue();
        }
      );
    } else if (
      list.length === 1 &&
      uploaded == "no" &&
      capture == "Document Upload"
    ) {
      console.log("---------------IF 9------------------: ");
      setDocumentId(list[0].Id);
      setOcrInfo(coreFunctions.GetOcrValue(list[0].Properties));
      setSectionId(list[0].Sections[0].Id);
      setSectionName(list[0].Sections[0].Name);
      setDocumentNameCurrent(list[0].Name);
      setBase64File(null);
      setShowAlert(false);
      setInitChangeFile(true);
      setExtensionsDoc(list[0]?.Sections[0]?.AllowedExtensions?.join(", "));
    }
  };

  console.log("IS SELFIE", isSelfie);

  const sendDocAction = () => {
    const dataToSend = {
      // To UploadSection
      B64Content: base64File,
      FileId: folioId,
      Actor_Id: actorId,
      SkipActor: null,
      SectionId: sectionId,
      Extension: extFileCurrent,
      Skip: false,
      SkipReason: null,
      Metadata: metadatos.length > 0 ? metadatos : null, //pending
      ContinueWorkFlow: false, //to upload all files before moving
      Geolocation: null, //Pending
      DeferLoad: false, // heavy file, true to load on backgroud
    };

    //this was used also in metadatos
    setLoadView(true);
    setSending(true);
    console.log("Request1_CargaSeccion: ", dataToSend);
    dispatch(documentsActions.CargaSeccion(dataToSend));
  };

  // const askforTransactionId = () => {
  //   const dataforMetadata = {
  //     // To UploadDocument
  //     File_id: folioId,
  //     Carga: {
  //       Referencia: folioId.toString(),
  //       TransactionId: transId,
  //       EsBolqueFin:
  //         sections.length === totalSections && sections.length > 1
  //           ? true
  //           : sections.length != totalSections && sections.length > 1
  //             ? false
  //             : true,
  //       TipoDocumento: documentNameCurrent,
  //       Seccion: sectionName,
  //       Imagenes: [
  //         {
  //           B64: base64File,
  //           Extension: extFileCurrent,
  //         },
  //       ],
  //       Metadatos: null,
  //     },
  //   };
  //   setLoadView(true);
  //   setUploadFileProcess(true)
  //   console.log("Request2_CargaDocumento: ", dataforMetadata)
  //   dispatch(documentsActions.CargaDocumento(dataforMetadata));
  // };

  // console.log(metadatos);

  // ESTA ES LA BUENA
  const askforTransactionId = () => {
    setLoadView(true);
    // console.log('CARGANDO NUEVA PETICION')
    let requestUpload = {
      UploadSectionRequestData: {
        B64Content: base64File,
        FileId: folioId,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: extFileCurrent ? extFileCurrent : ".jpg",
        Skip: false,
        SkipReason: null,
        Metadata: metadatos.length > 0 ? metadatos : null,
        ContinueWorkFlow: false,
        Geolocation: null,
        DeferLoad: false,
        OmitirMergeVideo: null,
        OmitirRemovebg: null,
        AsignarEstatusCarga: null,
      },
      File_id: folioId,
      Carga: {
        Referencia: folioId.toString(),
        TransactionId: transId,
        EsBolqueFin:
          sections.length === totalSections && sections.length > 1
            ? true
            : sections.length != totalSections && sections.length > 1
            ? false
            : true,
        TipoDocumento: documentNameCurrent,
        Seccion: sectionName,
        Imagenes: [
          {
            B64: base64File,
            Extension: extFileCurrent ? extFileCurrent : ".jpg",
          },
        ],
        Metadatos: null,
      },
    };
    setLoadView(true);
    setUploadFileProcess(true);
    dispatch(documentsActions.CargaDocumentoWithSection(requestUpload));
  };

  const RestoreValue = () => {
    documentTypesList.forEach((itemInput) => {
      setValue(itemInput.Name, null);
    });
  };

  const validationStatus = (doc) => {
    console.log("DOCUEMTNOS", doc);
    return (doc?.DocumentTypes || doc?.Types)?.map((dox) =>
      dox?.Document === undefined && dox?.Document === null
        ? t("document_pending")
        : dox?.Document?.Validation?.Approved === null
        ? t("document_captured")
        : dox?.Document?.Validation?.Approved === false
        ? t("document_rejected")
        : dox?.Document?.Validation?.Approved === true
        ? t("document_approved")
        : t("document_pending")
    );
  };

  const isDocRejected = (doc) => {
    //busca si hay docs rechazados
    const existRejected = (doc?.DocumentTypes || doc?.Types)?.filter(
      (dox) =>
        dox?.Document?.Validation?.Approved === false ||
        dox?.Document?.Validation?.Approved === null
    );
    console.log("existRejected", existRejected);
    if (existRejected.length > 0) return true;
    return false;
  };

  const validationColor = (doc) => {
    return (doc?.DocumentTypes || doc?.Types)?.map((dox) =>
      dox?.Document === undefined && dox?.Document === null
        ? "3"
        : dox?.Document?.Validation?.Approved === null
        ? "1"
        : dox?.Document?.Validation?.Approved === false
        ? "2"
        : dox?.Document?.Validation?.Approved === true
        ? "1"
        : "3"
    );
  };

  return (
    <GenericContainer>
      <FormProvider {...formMethods} theme={theme}>
        <GenericContainerCenter>
          {helpOpen && (
            <CaptureDocHelp
              open={helpOpen}
              closeAction={() => {
                setHelpOpen(false);
              }}
            />
          )}

          {texSubTittle && (
            <Typography variant="subtitle1">{texSubTittle}</Typography>
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {listDocsItems?.map((docItem, index) => {
              const isCapture = ifCapture(docItem.Types);
              console.log(
                "..................docItem...............: ",
                docItem
              );
              console.log(
                "showOnlyRejected",
                filterDocRefuseds && !isDocRejected(docItem) ? true : false
              );
              if (filterDocRefuseds && !isDocRejected(docItem)) return null; //omite otros status que no sean Rechazado
              return (
                <GenericButtonList
                  key={`btn_key_${docItem.Id}`}
                  id={`btn_key_${docItem.Id}`}
                  onClick={() => {
                    console.log("clickEventSelect ", docItem);
                    setTypeOfSelection(
                      docItem.Types,
                      isCapture ? "yes" : "no",
                      docItem.Capture
                    );
                  }}
                >
                  <GenericStatusElement
                    key={`list_element_key_${docItem.Id}`}
                    text={docItem.Required ? `${docItem.Name}*` : docItem.Name}
                    capture={docItem.Capture}
                    description={docItem.Description}
                    status={validationStatus(docItem)}
                    statusColor={validationColor(docItem)}
                  />
                </GenericButtonList>
              );
            })}
          </Box>
        </GenericContainerCenter>
        {continueButton && (
          <Buttons
            onClickConfirm={() => handleContinue()}
            marginBottom={IsDevice().IsMobile ? 50 : 1}
          />
        )}

        {loadView ? (
          <CustomLoadingOverlay
            active={loadView}
            text={t("general_loading_message")}
          />
        ) : null}
        {initCamera ? (
          (navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/Android/i)) &&
          !isSelfie ? (
            <CustomUploadCamera
              onCapture={(blob) => {
                console.log("camera return blob: ", blob);
                blobToBase64(blob).then((res) => {
                  // console.log("blobToBase64-------- Carga WEB----------", res)
                  let resultReplace = res.replace(
                    "data:image/jpeg;base64,",
                    ""
                  );
                  setBase64File(resultReplace);
                  setExtFileCurrent(".jpg");
                  setInitChangeFile(false);
                  setInitCamera(false);
                });
              }}
            />
          ) : (
            <FullCameraCapture
              open={initCamera}
              isSelfie={isSelfie}
              onClose={() => {
                setInitCamera(false);
                setShowDrawerOptionsType(false);
              }}
              onSendData={(data) => {
                // console.log("Data full camera: ", data)
                setBase64File(data);
                setExtFileCurrent(".jpg");
                setInitCamera(false);
                setInitChangeFile(false);
              }}
            />
          )
        ) : null}
        {showDrawerOptionsType ? ( //
          <SwipeableDrawer
            anchor="bottom"
            open={showDrawerOptionsType}
            classes={{ paper: localStyles.drawer }}
            onClose={() => {
              setShowDrawerOptionsType(false);
              setAskFile(false);
            }}
          >
            <Box className={localStyles.drawerCenter}>
              <Typography variant="h6">
                {listDocsItems[0]?.ActiveNSections == true
                  ? "Tipo de comprobante"
                  : "Tipo de documento"}
              </Typography>
              {listDocsItems[0]?.ActiveNSections == true ? null : (
                <Typography variant="subtitle1">
                  {t("cargar_select_type_document")}
                </Typography>
              )}
              {console.log(
                "*..................documentTypesList..............**: ",
                documentTypesList
              )}
              {documentTypesList.length == 0 ? (
                <span>{t("cargar_without_document_types")}</span>
              ) : (
                documentTypesList.map((itemInput) => (
                  <InputField
                    inputType="radio"
                    control={control}
                    name={`${itemInput.Name}`}
                    // label={itemInput.Name?.toUpperCase()}
                    radioValues={itemInput.Options}
                    validations={{ required: itemInput.Required }}
                    error={!!formState.errors[`${itemInput.Name}`]}
                    helperText={formState.errors[`${itemInput.Name}`]?.message}
                    required={itemInput.Required}
                    onSelect={(e, value) => {
                      console.log("RADIO itemInput", itemInput);
                      console.log("RADIO value: ", value);
                      setValue(`${itemInput.Name}`, value);
                      setDocumentId(value);
                      setOcrInfo(
                        coreFunctions.GetOcrValue(itemInput.Properties)
                      );
                      setDocumentNameCurrent(itemInput.Name);
                      setSectionId(itemInput.Sections[0].Id);
                      setSectionName(itemInput.Sections[0].Name);
                      setBase64File(null);
                    }}
                    disabled={itemInput.Disabled}
                  />
                ))
              )}
              <ButtonsLined
                ConfirmButtonText={t("general_accept")}
                onClickConfirm={handleSubmit((dataSelec) => {
                  AlertConfirm(
                    {
                      icon: "success",
                      html: (
                        <Box>
                          <Typography
                            textAlign={"center"}
                            variant="body1"
                            sx={{
                              mt: 1,
                              textAlign: "center",
                              maxWidth: 400,
                              mx: "auto",
                            }}
                          >
                            {t("document_upload_message")}
                          </Typography>
                        </Box>
                      ),
                      okbtntext: t("document_upload_file"),
                      notbtntext: t("document_upload_picture"),
                    },
                    (result) => {
                      if (result.isConfirmed) {
                        setInitChangeFile(true);
                      } else if (
                        result.dismiss === "cancel" &&
                        result.isDismissed
                      ) {
                        setInitCamera(true);
                        setExtFileCurrent(".jpg");
                      }

                      RestoreValue();
                    }
                  );
                })}
                onClickCancel={() => {
                  setShowDrawerOptionsType(false);
                  firstCloseLevel();
                  setBase64File(null);
                  RestoreValue();
                }}
              />
            </Box>
          </SwipeableDrawer>
        ) : null}
        {console.log(
          "openModalOCR && documenttoView*******: ",
          openModalOCR,
          documenttoView
        )}
        {openModalOCR && documenttoView ? (
          <SeeDocBeforeLoad
            open={openModalOCR}
            closeAction={closeDocAction}
            metadata={metadatos} //for metadata
            metaToSend={metaToSend}
            sendAction={askforTransactionId}
            setLoadFile={setLoadView}
            fields={fields}
            doc={documenttoView}
            docExt={extFileCurrent}
            setMetadatos={setMetadatos}
            folioId={folioId}
            docId={documentId}
            loading={loadView}
            ocrInfo={ocrInfo}
            setMetaToSend={setMetaToSend}
          />
        ) : null}

        {initChangeFile ? (
          <FullUploadFiles
            open={initChangeFile}
            DocName={documentNameCurrent}
            ExtensionsDoc={extensionsDoc}
            setInitChangeFile={setInitChangeFile}
            onClose={() => {
              setInitChangeFile(false);
              setShowDrawerOptionsType(false);
            }}
            onSendData={(data, extCurrent) => {
              console.log("Data upload file: ", extCurrent, data);
              setExtFileCurrent(`.${extCurrent}`);
              setBase64File(data);
              setLoadView(true);
              setInitChangeFile(false);
            }}
          />
        ) : null}
      </FormProvider>
      {IsDevice().IsMobile && (
        <div style={{ height: `${window.screen.height / 6}px` }}></div>
      )}
    </GenericContainer>
  );
}

const CaptureDocHelp = (props) => {
  const localStyles = useStyles();
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={props.open}
      onClose={props.closeAction}
      title="Carga documental"
      content={
        <Box
          sx={{
            display: "flex",
            position: "relative",
            height: "80vh",
            flexDirection: "column",
          }}
        >
          <Typography variant="subtitle1">
            {t("cargar_choose_type_document")}
          </Typography>
          <Typography
            variant="subtitle1"
            className={localStyles.helpInstruction}
          >
            {t("cargar_to_improve_capture")}
          </Typography>
          <Box className={localStyles.helpListInstructions}>
            <CancelIcon
              style={{ color: "red" }}
              className={localStyles.cancelIcon}
            />
            <Typography variant="subtitle1">
              {t("cargar_not_move_device")}
            </Typography>
          </Box>
          <Box className={localStyles.helpListInstructions}>
            <CancelIcon
              style={{ color: "red" }}
              className={localStyles.cancelIcon}
            />
            <Typography variant="subtitle1">
              {t("cargar_avoid_shadows_reflections")}
            </Typography>
          </Box>
          <Box className={localStyles.helpListInstructions}>
            <CancelIcon
              style={{ color: "red" }}
              className={localStyles.cancelIcon}
            />
            <Typography variant="subtitle1">
              {t("cargar_avoid_capturing_places")}
            </Typography>
          </Box>
          <UseImage src={cargaDocImg} />
        </Box>
      }
    />
  );
};
